import { Modal, OfficeButton } from "components";
import { useAppSearch } from "_graphql/cache/auth";

import { ApprovePaymentForm } from "components/forms";
import _ from "lodash";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import { useMutation } from "@apollo/client";
import { withPermissions, wrapClick } from "utils";
import { useOfferPayment } from "hooks/data/use-payments";
import { updateOfferPaymentApprovalStatus } from "_graphql/visal/queries/offers";
import {
  UpdatePaymentApproval,
  UpdatePaymentApprovalVariables,
} from "_graphql/visal/queries/__generated__/UpdatePaymentApproval";

export default function ApproveOfferContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const searchParam = useAppSearch();
  const { payment, loading } = useOfferPayment({ id: searchParam?.id || "" });
  const [setStatus, { loading: settingStatus }] = useMutation<
    UpdatePaymentApproval,
    UpdatePaymentApprovalVariables
  >(updateOfferPaymentApprovalStatus, {
    refetchQueries: ["Offers", "GetOfferPayments"],
  });
  const form = useFormik<any>({
    initialValues: {
      status: "",
      message: "",
    },
    onSubmit: async (variables) => {
      setStatus({
        variables: {
          rejectionReason: variables?.message,
          offerPaymentId: searchParam?.id || "",
          approvalStatus: variables?.status || "",
        },
      })
        .then(() => {
          toast.success("Payment status changed successfully!");
          setOpen?.(false);
        })
        .catch((error) => {
          console.error("Error changing payment status:", error);
          toast.error("Failed to change payment status.");
        });
    },
    onReset: () => {
      setOpen(false);
    },
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      title="Approve Payment"
      description="Review and approve the payment details before proceeding."
      renderActions={() => (
        <>
          {withPermissions(["*:*", "offers:*", "offers:payment"])(
            <OfficeButton
              disabled={settingStatus}
              onClick={wrapClick(form.handleSubmit)}
            >
              {settingStatus ? "Submitting..." : "Submit"}
            </OfficeButton>
          )}
        </>
      )}
    >
      <ApprovePaymentForm form={form} payment={payment || undefined} />
    </Modal>
  );
}
